import { render, staticRenderFns } from "./LessonNavItem.vue?vue&type=template&id=b40488da&"
import script from "./LessonNavItem.vue?vue&type=script&lang=js&"
export * from "./LessonNavItem.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports